(function ($) {
  DJ.addBehavior('userTabs', '.user-tabs', {
    attach: function () {
      $(`a[href="${window.location}"]`).addClass('is-active');
    }
  });
})(jQuery);
